import {
  ChakraProvider,
  extendTheme,
  Progress,
  useToast,
} from "@chakra-ui/react";
import { merge, tap } from "rxjs";

import { useEffect, useState } from "react";

import Web3Service from "./core/web3.service";

import HeaderNavigation from "./components/HeaderNavigation";
import MintView from "./components/MintView";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomeView from "./components/HomeView";
import RoyaltiesClaimer from "./components/RoyaltiesClaimer";
import TeamView from "./components/TeamView";
import GalleryView from "./components/GalleryView";
import StakingView from "./components/Staking";
import NFTStakingView from "./components/Staking/NFTStakeView";
import TokenStakingView from "./components/Staking/TokenStakeView";

function App(): any {
  const toast = useToast();
  const web3Service = Web3Service.shared();

  const [isLoading, setIsLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [account, setAccount] = useState<string>();

  useEffect(() => {
    web3Service.connectToCachedProvider();

    const connected$ = web3Service.connected$.pipe(
      tap((connected) => {
        setConnected(connected);
      })
    );

    const account$ = web3Service.account$.pipe(
      tap((account) => {
        setAccount(account);
      })
    );

    const showToast$ = web3Service.showToast$.pipe(
      tap((info: { title: string }) => {
        toast({
          description: info.title,
          status: "success",
          position: "bottom-left",
        });
      })
    );

    const errors$ = web3Service.errors$.pipe(
      tap((error) => {
        toast({
          description: error,
          status: "error",
          position: "bottom-left",
        });
      })
    );

    const isLoading$ = web3Service.isLoading$.pipe(
      tap((isLoading) => {
        setIsLoading(isLoading);
      })
    );

    const subscription = merge(
      connected$,
      showToast$,
      errors$,
      account$,
      isLoading$
    ).subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const config = {
    initialColorMode: "dark",
    useSystemColorMode: false,
  };

  const styles = {
    global: () => ({
      body: {
        bg: "black",
      },
    }),
  };

  const fonts = {};

  const theme = extendTheme({
    config,
    fonts,
    styles,
  });

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <HeaderNavigation
          isConnected={connected}
          account={account}
          isCorrectChainId={web3Service.isCorrectChainId()}
          toggleConnect={web3Service.toggleConnect}
          switchNetwork={web3Service.switchNetwork}
        />

        <Progress
          colorScheme={"purple"}
          sx={{ position: "sticky", top: "0", zIndex: "999" }}
          size="xs"
          isIndeterminate
          opacity={isLoading ? 100 : 0}
        />

        <Routes>
          <Route path="/my-nfts" element={<GalleryView />} />
          <Route path="/mint" element={<MintView />} />
          <Route path="/royalties" element={<RoyaltiesClaimer />} />
          <Route path="/team" element={<TeamView />} />
          <Route path="/staking" element={<StakingView />} />
          <Route path="/" element={<HomeView />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
